// TODO: Remove
import LocalStorageController from 'core-components/classes/services/LocalStorageController'

export const set = (key: string, value: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    LocalStorageController.setItem(key, value)
  } else {
    sessionStorage.setItem(key, value)
  }
}

export const get = (key: string) => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.getItem('simulation')) {
    return LocalStorageController.getItem(key)
  }
  return sessionStorage.getItem(key)
}
